import { NetworkBasePopUp } from '../NetworkBasePopUp';
import { GzDialog } from '../../../../ui/gzDialog/component/GzDialog';
import { translateFn } from '../../../../utils/translator.helper';
import { CreateTaskRequest } from '../../types';
import { TaskType } from '../../../../tasks/networkTasks/types';
import { FooterButton } from '../NetworkPopUpFooterContentWebComponent';
import { ButtonColors, ButtonTypes } from '../../../../ui/gzButton/types';
import { GzResumeProtectionComponent } from './component/GzResumeProtectionComponent';

export class ResumeProtectionPopUp extends NetworkBasePopUp<GzResumeProtectionComponent> {
  protected extraDialogConfigs: Partial<GzDialog> = { isWindow: false };
  protected title = translateFn('Resume endpoint protection?');
  protected transformToTaskTarget = true;
  protected popUpFooterButtons: Partial<FooterButton>[] = [
    {
      type: ButtonTypes.FULL,
      id: 'confirmButton',
      color: ButtonColors.PRIMARY,
      label: translateFn('Resume'),
    },
    {
      type: ButtonTypes.OUTLINE,
      id: 'closeButton',
      color: ButtonColors.SECONDARY,
      label: translateFn('Cancel'),
    },
  ];

  protected customSetup(): void {
    this.popUpContent = new GzResumeProtectionComponent();
  }

  protected async handleConfirmButtonClicked(event: CustomEvent): Promise<void> {
    if (!this.data.targets) {
      throw new Error('Targets are not defined');
    }

    const endpointId = this.data.targets[0].specifics.endpointId;

    if (!endpointId) {
      throw new Error(`EndpointId is not defined for protected entity ${this.data.targets[0]._id}`);
    }

    const request: CreateTaskRequest = {
      settings: {
        specifics: {
          endpointId: endpointId,
          runFullScan: Boolean(this.popUpContent?.createFullScanTask?.checked),
        },
        taskName: translateFn('Resume protection {date}', { date: new Date().toISOString().split('T')[0] }),
        targets: this.data.targets,
        type: TaskType.TASK_TYPE_RESUME_PROTECTION_PARENT,
      },
    };

    await this.createTask(request);
  }
}
